<script lang="ts">
    import {getInjector} from 'src/core';
    import {Spacer} from 'shared/layouts';
    import type {Thread} from 'src/features/threads/threads.types';
    import {ThreadsContextService} from 'src/features/threads/services/threads-context.service';
    import {onDestroy} from 'svelte';
    import {cleanup} from 'shared/utils/custom-utils';
    import ThreadIcon from 'src/features/threads/shared-components/ThreadIcon.svelte';

    export let thread: Thread;
    export let selected = false;

    const threadContextService = getInjector().getByClass(ThreadsContextService);

    let notificationsCount = 0;
    const notificationsCountSubscription = threadContextService.context$.subscribe((context) => {
        notificationsCount = context.unreadMessages.get(thread.id) ?? 0;
    });

    onDestroy(() => {
        cleanup(notificationsCountSubscription);
    });
</script>

<button class="thread-card-button"
        class:thread-selected={selected}
        class:has-notifications={!selected && notificationsCount > 0}
        on:click>

    <ThreadIcon {thread} sizePx={24} tooltipsDisabled/>

    <span class="thread-name">{thread.name}</span>

    {#if notificationsCount > 0}
        <Spacer flex="1"/>
        <span class="notifications-count">{notificationsCount}</span>
    {/if}
</button>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";
    @import (reference) "styles/portaro.themes.less";

    .thread-card-button {
        display: flex;
        align-items: center;
        width: 100%;
        padding: @spacing-s @spacing-sm;
        gap: @spacing-s;
        position: relative;
        outline: none;
        background: none;
        border: none;
        cursor: pointer;
        isolation: isolate;

        &:hover {
            &:before {
                background-color: @themed-panel-bg;
            }
        }

        &.has-notifications {
            .notifications-count {
                color: var(--danger-red);
            }

            &:before {
                border-color: var(--danger-red);
            }
        }

        &.thread-selected {
            &:before {
                background-color: @themed-body-bg-blue-highlighted;
                border-color: var(--accent-blue);
            }
        }

        &:before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            border-radius: @border-radius-default;
            border: 1px solid transparent;
            background-color: transparent;
            transition: background-color 0.3s ease-in-out, border-color 0.3s ease-in-out;
            z-index: -1;
        }
    }
</style>